import {useEffect, useState} from 'react';

import {isDoNotSellRequested, onConsentChange} from './consent';

/**
 * Whether the visitor has asked not to have their information sold or shared, kept current.
 *
 * `isDoNotSellRequested` reads Termly's state and the GPC signal at the moment it is called, so
 * a component calling it directly captures the answer at render and never hears about a later
 * change. Nothing re-renders on a Termly consent change, which left a gap: someone who opened
 * the preference centre and opted out partway through would keep whatever the form had already
 * rendered with, and the hidden `do_not_sell` field would be missing when they submitted.
 *
 * A withdrawal of analytics or advertising does reload the page, which happened to paper over
 * the common case. It does not cover opting out while granting every category at once, because
 * nothing was granted beforehand for the reload to trigger on.
 *
 * Seeds `false` rather than reading the signal during the first render: this runs server-side
 * too, where there is no `window`, and returning different values on the server and the client
 * is a hydration mismatch. `onConsentChange` fires its handler immediately, so the real value
 * lands in the first effect.
 */
const useDoNotSell = (): boolean => {
    const [doNotSell, setDoNotSell] = useState(false);

    useEffect(() => onConsentChange(() => setDoNotSell(isDoNotSellRequested())), []);

    return doNotSell;
};

export default useDoNotSell;
